import {
  HeroSection,
  FindMyPartSection,
  FeaturedPartsSection,
  PromotionalBannersSection,
  ShopByCarCategorySection,
  FeaturedCarsSection,
  FigmaBottomSections,
  FigmaFooterSection,
} from '@/components/landing'

export function HomePage() {
  return (
    <div className="space-y-0 overflow-hidden bg-background">
      {/* Hero + Search */}
      <HeroSection />

      {/* 5-STEP FIND MY PART + 11 MASTER CATEGORIES */}
      <FindMyPartSection />

      {/* FEATURED NEW PARTS */}
      <FeaturedPartsSection />

      {/* CERTIFIED PRE-OWNED CARS | GENUINE & OLD PARTS banners */}
      <PromotionalBannersSection />

      {/* SHOP BY CAR CATEGORY */}
      <ShopByCarCategorySection />

      {/* FEATURED PRE-OWNED CARS */}
      <FeaturedCarsSection />

      {/* FIGMA BOTTOM SECTIONS (Testimonials & Verified Reviews, Dual Banners, Trust Badges) */}
      <FigmaBottomSections />

      {/* FIGMA FOOTER SECTION (Custom Sourcing Form, 22% Tire Discount Banner, Corporate Office Footer & EXOTIC AUTO CART Watermark) */}
      <FigmaFooterSection />
    </div>
  )
}
